module.exports = __webpack_public_path__ + "static/media/023A color panel.7a983ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/023A color panel.png
// module id = 520
// module chunks = 0